import { FormSelectField } from "@/components/form/FormSelectField";
import type { SelectOption } from "@/components/ui/SelectInput";
import type { LocationId } from "../hooks/useFeedbackForm";

export const LOCATION_OPTIONS = [
  { value: "card_collection", label: "Card Collection" },
  { value: "patient_accounting", label: "Patient Accounting" },
] satisfies SelectOption<LocationId>[];

interface FeedbackLocationFieldProps {
  name: string;
  label?: string;
}

export function FeedbackLocationField({
  name,
  label = "where",
}: FeedbackLocationFieldProps) {
  return (
    <FormSelectField
      name={name}
      label={label}
      options={LOCATION_OPTIONS}
      data-testid="feedback-location-select"
    />
  );
}
